import React from 'react';

import {hooks} from '../../hooks';
import {components} from '../../components';
import {theme} from '../../constants';

export const EmailVerified: React.FC = () => {
  const navigate = hooks.useAppNavigate();

  const renderContent = () => {
    return (
      <div style={{padding: '50px 20px 20px 20px'}}>
        <img
          src={require('../../assets/icons/17.png')}
          alt='order successful'
          style={{
            width: 225.18,
            display: 'block',
            margin: '0 auto',
            marginBottom: 14,
          }}
        />
        <h2
          style={{
            margin: 0,
            textAlign: 'center',
            ...theme.fonts.Mulish_700Bold,
            fontSize: 22,
            lineHeight: 1.2,
            color: theme.colors.mainColor,
            marginBottom: 14,
            textTransform: 'capitalize',
            whiteSpace: 'pre-line',
          }}
        >
          ایمیل شما{'\n'}با موفقیت تأیید شد!
        </h2>
        <p
          style={{
            margin: '0 20px',
            textAlign: 'center',
            color: theme.colors.textColor,
            lineHeight: 1.7,
            marginBottom: 30,
          }}
        >
          اکنون که رسماً بخشی از انجمن{'\n'}ما هستید، می‌توانید لذت ببرید تمام
          ویژگی های برنامه ما
        </p>
        <components.Button
          title='انجام شد'
          onClick={() => {
            navigate('/home');
          }}
          containerStyle={{marginBottom: 10}}
        />
      </div>
    );
  };

  return renderContent();
};
